import * as React from 'react';
import { PVASelect, PVASelectOption } from '../../../components';
import { CharacteristicGroup, Characteristic, CharacteristicGroupCharacteristic, SurveyVersion, SurveyReportType } from '../../../models';
import { CharacteristicGroupDataService, CharacteristicDataService, NotificationService, SurveyVersionDataService, SurveyReportTypeDataService } from '../../../services';
import { FilterStore } from '../../../stores';
import { observer, inject } from 'mobx-react';
import './PVASelect.css';

interface PVACharacteristicFilterSelectProps {
    surveyVersionId: number;
    selected: number | undefined;
    onChange: Function;
    FilterStore?: FilterStore;
    notificationService: NotificationService;
    disabled?: boolean;
}

interface PVACharacteristicFilterSelectState {
    isOpen: boolean;
    groups: CharacteristicGroup[];
    options: Characteristic[];
    surveyReportTypes: SurveyReportType[];
    surveyReportType: SurveyReportType | undefined;
}

@inject('FilterStore') @observer
export class PVACharacteristicFilterSelect extends React.Component<PVACharacteristicFilterSelectProps, PVACharacteristicFilterSelectState> {
    private characteristicGroupDataService = new CharacteristicGroupDataService(this.props.notificationService);
    private characteristicDataService = new CharacteristicDataService(this.props.notificationService);
    private surveyVersionDataService = new SurveyVersionDataService(this.props.notificationService);
    private surveyReportTypeService = new SurveyReportTypeDataService(this.props.notificationService);

    constructor(props: PVACharacteristicFilterSelectProps) {
        super(props);

        this.state = {
            isOpen: false,
            groups: [],
            options: [],
            surveyReportTypes: [],
            surveyReportType: undefined
        };
    }

    componentDidMount() {

        this.surveyVersionDataService.get(this.props.surveyVersionId).then((surveyVersion: SurveyVersion) => {

            this.characteristicGroupDataService.getAllBySurveyVersion(surveyVersion).then((characteristicGroups: CharacteristicGroup[]) => {
                this.setState({
                    groups: characteristicGroups
                });
            });

            this.characteristicDataService.getAllBySurveyVersion(surveyVersion).then((characteristics: Characteristic[]) => {
                if (characteristics && characteristics.length > 0) {
                    characteristics.sort((c1: Characteristic, c2: Characteristic) => {
                        if (c1.name > c2.name) {
                            return 1;
                        } else if (c1.name < c2.name) {
                            return -1;
                        }
                        return 0;
                    });
                    this.setState({
                        options: characteristics
                    });
                }
            });

            this.surveyReportTypeService.getBySurvey(surveyVersion.surveyID).then((surveyReportTypes: SurveyReportType[]) => {
                this.setState({
                    surveyReportTypes: surveyReportTypes
                });
            });
        });
    }

    private selectedCharacteristic() {
        if (!this.props.selected) {
            return null;
        }
        
        var char = this.state.options.find((c: Characteristic) => {
            return c.id === this.props.selected;
        });
        if (char) {
            return char;
        }
        return undefined;
    }

    private characteristicChange(characteristic: Characteristic) {
        if (this.props.onChange) {
            this.props.onChange({
                target: {
                    value: characteristic.id
                }
            });
        }
        this.setState({ isOpen: !this.state.isOpen });
    }

    characteristicSort(a: Characteristic, b: Characteristic) {
        if (a.sort > b.sort) {
            return 1;
        }
        if (a.sort < b.sort) {
            return -1;
        }
        return 0;
    }

    characteristicGroupCharacteristicSort(a: CharacteristicGroupCharacteristic, b: CharacteristicGroupCharacteristic) {
        if (a.sort > b.sort) {
            return 1;
        }
        if (a.sort < b.sort) {
            return -1;
        }
        if (a.characteristic && b.characteristic) {
            if (a.characteristic.sort > b.characteristic.sort) {
                return 1;
            }
            if (a.characteristic.sort < b.characteristic.sort) {
                return -1;
            }
        }
        return 0;
    }

    private selectReportType(e: any) {
        var id: number = parseInt(e.target.value, 10);
        var srt: SurveyReportType | undefined = this.state.surveyReportTypes.find((surveyReportType: SurveyReportType) => {
            return surveyReportType.id === id;
        });

        this.setState({
            surveyReportType: srt
        });
    }
    
    render() {

        var characteristicSelected = this.selectedCharacteristic();
        var offset = 0;

        var reportTypeOptions: PVASelectOption[] = [];
        this.state.surveyReportTypes.sort((srt1: SurveyReportType, srt2: SurveyReportType) => {
            if (srt1.sort > srt2.sort) { return 1; }
            if (srt1.sort < srt2.sort) { return -1; }
            return 0;
        }).map((srt: SurveyReportType) => {
            reportTypeOptions.push({
                id: srt.id,
                label: srt.name
            });
        });

        return (
            <div className="row">
                <div className="col-xs-6">
                    <PVASelect keepNoSelect={true} noSelectTitle={'- Report Type Filter -'} stretch={true} options={reportTypeOptions} onChange={(e: any) => { this.selectReportType(e); }} selected={this.state.surveyReportType ? this.state.surveyReportType.id : 0} disabled={this.props.disabled} />
                </div>
                <div className="col-xs-6">
                    <div className={`pva-select-box stretch ${this.props.disabled ? 'disable-control' : ''}`} tabIndex={this.props.disabled ? -1 : 0}>
                        <div className={`pva-select-box-selected ${this.state.isOpen ? 'open' : ''}`} onClick={(e) => !this.props.disabled && this.setState({ isOpen: !this.state.isOpen })}>
                            {characteristicSelected &&
                                <div className="user-row">
                                    <span>{characteristicSelected.name} </span>
                                </div>
                            }
                            {!characteristicSelected &&
                                <div className="user-row">
                                    <span>- Select -</span>
                                </div>
                            }
                            <div className="pva-select-box-toggle">
                                {!this.state.isOpen && <span className="glyphicon glyphicon-triangle-bottom" />}
                                {this.state.isOpen && <span className="glyphicon glyphicon-triangle-top" />}
                            </div>
                        </div>
                        {this.state.isOpen &&
                            <div className="pva-select-box-options">
                                {
                                    this.state.surveyReportType && this.state.groups
                                        .filter((group: CharacteristicGroup) => {                            
                                            if (!this.state.surveyReportType || !group.surveyReportTypeID) {
                                                return true;
                                            }
                                            return group.surveyReportTypeID === this.state.surveyReportType.id;
                                        })
                                        .map((group: CharacteristicGroup, index: number) => {
                                            var off = offset;
                                            offset += group.characteristics.length;

                                            return <div key={`select-opt-${group.id}`}>
                                                <div className="title-header">{group.name}</div>
                                                {
                                                    group.characteristics.sort(this.characteristicSort).map((c: Characteristic, ind: number) => {
                                                        return <div className="user-row" onClick={(e) => this.characteristicChange(c)} key={`characteristic-${c.id}`}> {off + ind + 1}. {c.displayName ? c.displayName : c.name}</div>;
                                                    })
                                                }
                                                {
                                                    group.characteristicGroupCharacteristics.sort(this.characteristicGroupCharacteristicSort).map((c: CharacteristicGroupCharacteristic, ind: number) => {
                                                        return <div className="user-row" onClick={(e) => c.characteristic && this.characteristicChange(c.characteristic)} key={`characteristic-${c.characteristic && c.characteristic.id}`}> {off + ind + 1}. {c.characteristic && (c.characteristic.displayName ? c.characteristic.displayName : c.characteristic.name)}</div>;
                                                    })
                                                }
                                            </div>;
                                        })
                                }
                                {!this.state.surveyReportType && <div>
                                    <div className="title-header">All Characteristics</div>
                                    {
                                        this.state.options.map((o: Characteristic, cInd: number) => {
                                            return <div className="user-row" onClick={(e) => this.characteristicChange(o)} key={`characteristic-${o.id}`}> {cInd + 1}. {o.displayName ? o.displayName : o.name}</div>;
                                        })
                                    }
                                </div>}
                            </div>}
                    </div>
                </div>
            </div>
            );
    }
}


// WEBPACK FOOTER //
// ./src/components/reports/blocks/PVACharacteristicFilterSelect.tsx